import UserInfoService from './UserInfoService.js'

const state = {
  userInfo: null
}

const getters = {
  userInfo: state => state.userInfo
}

const actions = {
  async getUserInfo({ commit, state }) {
    // UserInfoService.getCachedUserInfo().then(res => {
    //   commit(STORE_USERINFO, res)
    // })
    const result = await UserInfoService.getCachedUserInfo()
    commit('setUserInfo', result)
  },
  setUserInfo({ commit }, data) {
    commit('setUserInfo', data)
  }
}

const mutations = {
  setUserInfo(state, data) {
    state.userInfo = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
